import React from 'react';
import Layout from '../../components/Layout';
import PasswordVerification from './PasswordVerification';
import NotFound from '../notFound/NotFound';
import { decode } from '../../helpers/queryEncryption';
import messages from '../../locale/jsonMessages';

export default async function action({ store, query, intl }) {

  const title = intl?.formatMessage(messages.forgotPasswordTabTile);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;
  let email, token, encodeEmail;
  if (isAuthenticated) {
    return { redirect: '/' };
  }

  encodeEmail = query?.email?.replace(/ /g, '+');

  if ('token' in query && 'email' in query) {
    token = query.token
  } else {
    return {
      title,
      component: <Layout><NotFound title={title} /></Layout>,
      status: 404,
    };
  }

  return {
    title,
    component: <Layout><PasswordVerification email={encodeEmail} token={token} title={title} encodeEmail={encodeEmail} /></Layout>,
  };
};
